export default "__VITE_ASSET__DBlJk4Zz__"